var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gateprediction"}},[_c('p',[_vm._v("I think there will be")]),_c('h2',[_vm._v(_vm._s(_vm.gates))]),_c('p',[_vm._v("gates open at "+_vm._s(_vm.weirName)+" today")])])}
var staticRenderFns = []

export { render, staticRenderFns }